module.exports = __webpack_public_path__ + "static/media/IMG_1340.a4f4bf99.jpg";